<template>
  <div>
    <el-upload
      accept="*"
      ref="upload"
      action="#"
      multiple
      list-type="picture-card"
      :file-list="data || []"
      :auto-upload="false"
      style="width: 378px"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url" alt=""
        >
        <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in" style="font-size: 14px"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                    style="margin-left: 4px"
                  >
                    <i class="el-icon-delete" style="font-size: 14px"></i>
                  </span>
                </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" width="300px" append-to-body>
      <img width="100%" :src="imageDialogUrl">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Upload",
  props: {
    data: {
      type: Array,
      default: () => []
    },
  },
  data(){
    return{
      dialogVisible: false,
      imageDialogUrl:'',
      file:[]
    }
  },
  methods:{
    handleRemove(file) {
      const uid = file.uid
      const fileList = this.$refs['upload'].uploadFiles
      console.log(fileList)
      const index = fileList.findIndex(item => item.uid === uid)
      console.log(index)
      fileList.splice(index, 1)
    },
    handlePictureCardPreview(file) {

      this.imageDialogUrl = file.url;
      this.dialogVisible = true
    },
    getFiles(){
      return this.$refs['upload'].uploadFiles
    },
    handleExceed(files){
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`);
    }
  }
}
</script>

<style scoped>

</style>
